module.exports = __webpack_public_path__ + "media/images/gallery/constellations/triangulum/tri_gal-e4a707a24996787fd85bb438b3c66adc.gif";